import { Component } from '@angular/core';
import { GlobalState } from '../../global.state';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  constructor(private _state: GlobalState,
              private AuthService: AuthService,
              private router: Router) { }

  public toggleMainMenu(): void {
    this._state.changeMainMenu();
  }

  public logout(): void {
    this.AuthService.logoutUser();
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/core/header/header.component.ts